module.exports = __webpack_public_path__ + "fonts/OpenSans-ExtraBold.312244c.ttf";